export type UploadToS3Options = {
  onProgress?: (progress: number) => void;
  /**
   * Only pass this when the presign request signed a content type (e.g. album
   * videos). Sending it against a presign that didn't include it makes S3
   * reject the PUT with a signature mismatch.
   */
  contentType?: string;
};

/** PUT a file to a presigned S3 URL, reporting progress as 0–100. */
export function uploadToS3WithProgress(
  presignedUrl: string,
  file: File,
  { onProgress, contentType }: UploadToS3Options = {},
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        onProgress?.(Math.round((event.loaded / event.total) * 100));
      }
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error(`Upload failed with status ${xhr.status}`));
      }
    };

    xhr.onerror = () => reject(new Error("Upload failed"));
    xhr.onabort = () => reject(new Error("Upload cancelled"));

    xhr.open("PUT", presignedUrl);
    if (contentType) {
      xhr.setRequestHeader("Content-Type", contentType);
    }
    xhr.send(file);
  });
}
